import { isPalmettoFinanceUser } from '@/components/auth/RequirePricingAdminUser';
import { ReactNode } from 'react';

import { UserPermissions } from 'types';

import { useAuth } from './authProvider';

export const RequirePayoutsAccountingAdminUser = ({ children }: { children: ReactNode }) => {
  const { claims } = useAuth();
  const isPalmettoFinance = isPalmettoFinanceUser(claims);
  const isLightReachAccountingAdmin = claims?.permissions?.includes(UserPermissions.lightReachAccountingAdmin);
  return isPalmettoFinance && isLightReachAccountingAdmin ? <>{children}</> : null;
};
